<template>
    <Page withNavbar withNavigation>
        <main>
            <SectionTitle :title="config.PROFILE_EDIT_TITLE"/>
            <section class="infos">
                <p>{{ config.PROFILE_INFO_GENERAL_TITLE }}</p>
                <form>
                    <Input
                        v-model="form.user.lastName"
                        type="text"
                        :label="config.PROFILE_INFO_GENERAL_SURNAME"
                        :placeholder="config.PROFILE_INFO_GENERAL_SURNAME"
                    />
                    <Input
                        v-model="form.user.firstName"
                        type="text"
                        :label="config.PROFILE_INFO_GENERAL_FIRSTNAME"
                        :placeholder="config.PROFILE_INFO_GENERAL_FIRSTNAME"
                    />
                    <Input
                        v-model="form.user.birthdate"
                        type="date"
                        :label="config.PROFILE_INFO_GENERAL_BIRTHDATE"
                        :placeholder="config.PROFILE_INFO_GENERAL_BIRTHDATE"
                    />
                    <Input
                        v-model="form.user.email"
                        type="text"
                        :label="config.PROFILE_INFO_GENERAL_EMAIL"
                        :placeholder="config.PROFILE_INFO_GENERAL_EMAIL"
                    />
                    <InputPhone
                        v-model="form.user.phone"
                        :label="config.PROFILE_INFO_GENERAL_PHONE"
                        :placeholder="config.PROFILE_INFO_GENERAL_PHONE"
                    />
                    <div v-show="user.allowedOtherCampaigns" class="campaigns-checkbox">
                        <label>{{ config.PROFILE_INFO_GENERAL_CAMPAIGN }}</label>
                        <Checkbox v-model="form.user.campaignsOption">
                            {{ config.PROFILE_INFO_GENERAL_CAMPAIGN_LABEL }}
                        </Checkbox>
                    </div>
                </form>
            </section>
            <router-link tag="section" :to="{ name: 'profile.privacy' }" class="privacy">
                <p>{{ config.PROFILE_PRIVACY_TITLE }}</p>
                <ChevronRight :color="config.COLOR_PRIMARY"/>
            </router-link>
            <SectionActions>
                <Button :color="config.COLOR_PRIMARY" :disabled="form.loading" flat @click="onCancel">
                    {{ config.PROFILE_EDIT_CANCEL }}
                </Button>
                <Button :color="config.COLOR_PRIMARY" :disabled="form.loading" @click="onSubmit">
                    {{ config.PROFILE_EDIT_SAVE }}
                </Button>
            </SectionActions>
        </main>
    </page>
</template>
<script>
import { SolutionConsumer, UserConsumer } from '../../mixins';
import { Page } from '../../components/mobile';
import { SectionTitle, SectionActions } from '../../components/shared';

export default {
    name: 'ProfileEditGeneral',
    components: { Page, SectionTitle, SectionActions },
    mixins: [SolutionConsumer, UserConsumer],
    data () {
        return {
            loading: false,
            form: {
                user: {},
            },
        };
    },
    created () {
        // Initialize form from user information
        this.form.user = {
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            email: this.user.email,
            phone: this.user.phone,
            birthdate: this.user.birthdate,
            social: {
                twitter: this.user.social.twitter,
                instagram: this.user.social.instagram,
                youtube: this.user.social.youtube,
                snapchat: this.user.social.snapchat,
                facebook: this.user.social.facebook,
                website: this.user.social.website,
            },
            campaignsOption: this.user.campaignsOption,
        };
    },
    methods: {
        onCancel () {
            this.$router.go(-1);
        },
        async onSubmit () {
            try {
                this.loading = true;

                // Update user info
                await this.editUser({
                    ...this.form.user,
                    campaignsOption:
                    // if value was not updated - send null because we do not need a log for this.
                      this.user.campaignsOption === this.form.user.campaignsOption
                          ? null
                          : this.form.user.campaignsOption,
                });
                // Update local copy
                await this.updateUser();
                this.$router.push({ name: 'profile' });
            } catch (err) {
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

main {
    @include container(40px 20px);

    > section {
        &.infos {
            > p {
                margin-bottom: 20px;
            }

            > form {
                @include card(20px);
                display: grid;
                row-gap: 10px;
            }

          .campaigns-checkbox {
            > label:first-child {
              display: block;
              padding: 8px 0;
              font-size: 12px;
              font-weight: 400;
              color: $black;
            }
          }
        }

        &.privacy {
            @include card(20px);
            display: flex;
            align-items: center;
            justify-content: space-between;

            > p {
                margin: 0;
            }
        }

        &.address {
            > p {
              margin-bottom: 20px;
            }
            > div {
                @include card(20px);
                display: grid;
                row-gap: 10px;
            }
        }
    }
}
</style>
